<template>
  <div class="grid comment-count" :class="commentClass">
    <div class="grid__col--1 h-no-padding h-center-align">
      <i class="far fa-comments"></i>
    </div>
    <div class="grid__col--11 h-no-margin h-no-padding">{{ commentCountText }}</div>
  </div>
</template>
<script>
  import { mapGetters } from 'vuex';
  import lodash from 'lodash';

  export default {
    name: 'CommentCount',
    props: ['item'],
    data() {
      return {
        commentClass: '',
      };
    },
    computed: {
      ...mapGetters('meetingAgendas', ['currentAgenda', 'currentAgendaItem']),
      commentCount() {
        return lodash.filter(this.currentAgenda.comments, (comment) => comment.item_id === parseInt(this.item.id)).length;
      },
      commentCountText() {
       return `${this.commentCount} Comment${ this.commentCount === 1 ? '' : 's'}`;
      },
    },
    watch: {
      commentCount(newVal, oldVal) {
        if (newVal > oldVal && (!this.currentAgendaItem || this.currentAgendaItem.id !== this.item.id)) {
          this.commentClass = 'comment-count--change';
        }
      },
      currentAgendaItem() {
        if (this.currentAgendaItem && this.currentAgendaItem.id === this.item.id) {
          this.commentClass = '';
        }
      },
    },
  };
</script>
